import axios from 'axios';

export default async function getFileSize(url: string) {
  const response = await axios.head(url);
  const fileSize = response.headers['content-length'];

  return fileSize;
}
